module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAABaUlEQVQ4T9XUO2uUQRSH8d8YQQKS2CiCF0IuYKNIUDAW0TKQCGkEsbK2SfAT+BWsbbQQUQSxcisxnaaw0FZIzM2QQqMiAVEmHJldXjd7K+O/GZiZ88y5zUmKcs4XMI1U3+uwZtRSSm/jTsMg53wDR7DcA2QIOymlh60g2ymlWjdIznkKx1NKD/YZJOcceQhdw3csdAsHV3AUz/6Gk3O+24NRxyvNkJcYxOVi9QpbOIRL+IF3OIBRjDd78gXPsY159CGyP4Gv+ICzWMck7uN2tEXVk9flxU84jzMFcg7f8BnDWCpePcEc+quQezhRXD6M6wVyEKdwEe+xiDEEPO43EruKF5jBHzzFHTzGVUSHht5gE7PVTNc9WcOv4m6cx4unsYGTGChGAfiJkWbIrbJxrKzRK90U0KhQQPd8wP/979SDL/MkSvuxW0JKt/5uNwqiwaqKcj/CTUS/VLXUaii1G48rpdxVwD/jcRcTS5/qoBG0XgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/appdownload.png
// module id = DHnq
// module chunks = 44